import type { ReusedOptions } from '../../../types/ReusedOptions.js';

/**
 * Defines the options for the "init" command.
 */
export interface InitOptions extends Pick<
  ReusedOptions,
  'app' | 'cache' | 'logBundleInfo' | 'logResolveMap' | 'match'
> {
  /**
   * Ignore the previous generated config.
   */
  reset?: boolean;

  /**
   * Fail if updates to the generated config are required.
   */
  check?: boolean;
}
